<template>
  <div class="photo">
    <header>
      <div class="tab-c">
        <div :class="tab == 'H' ? 'active' : ''" @click="changeTab('H')">电脑端写真</div>
        <div :class="tab == 'V' ? 'active' : ''" @click="changeTab('V')">移动端写真</div>
      </div>
      <div class="upload-tip">
        上传写真通过后即可展示在您的歌曲播放页
        <span>
          查看示例
          <img src="../assets/img/uploadimg-tip.png" alt="" srcset="" />
        </span>
      </div>
    </header>
    <div class="tip">
      写真规范：高清写真（PC端横版）：1920*1080px，小于10MB；高清小写真（手机端竖版）：720*1280px，小于10MB。<br>
      <div v-show="tab == 'H'">（电脑端写真 审核通过7天后显示）</div>
    </div>
    <div :class="`list ${tab}`">
      <div class="add" :style="`height: ${imgBoxHeight[tab]}px;${tab == 'H' ? 'width: 22.9%;margin-left:2.76%' : 'width: 17.9%;margin-left:2.58%'}`" @click="autoClick">
        <img class="center-y" :src="require(`../assets/img/add_photo_${tab}.png`)" alt="" srcset="" />
      </div>
      <div
        v-for="(item, index) in showArr"
        :key="index"
        :style="`height: ${imgBoxHeight[tab]}px;${tab == 'H' ? 'width: 22.9%;margin-left:2.76%' : 'width: 17.9%;margin-left:2.58%'}`"
      >
        <div class="reason" v-show="item.review_message">
          <div class="reason-text">{{item.review_message}}</div>
        </div>
        <div class="checking" v-show="item.review_status == 1">
          <div class="reason-text">{{verifyStatus[item.review_status]}}</div>
        </div>
        <div class="delete" @click="deletePic(item, index, item.review_status)"></div>
        <img class="center-y" :src="replaceHttpsImg(item.portrait)" alt="" srcset="" />
        <div class="status" v-show="item.review_status == 3">
          <p class="text">{{verifyStatus[item.review_status]}}</p>
        </div>
        <div class="status" v-show="item.review_status != 3">
          <p class="preview-text" @click="peviewImage(replaceHttpsImg(item.portrait))">点击预览</p>
        </div>
      </div>
    </div>
    <div class="cropper-dialog-contaier el-dialog__wrapper" :style="`opacity:${cropper?1:0};z-index:${cropper?'100':'-1'};top:${cropper?0:'-100%'};left:${cropper?0:'-100%'}`">
      <div class="cropper-dialog el-dialog">
        <div class="cropper-dialog-header el-dialog__header">
          <span class="cropper-dialog-title el-dialog__title">图片裁剪</span>
          <button class="cropper-dialog-close el-dialog__headerbtn" type="button" @click="hideCropper">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </div>
        <div class="el-dialog__body cropper-content" style="width: 600px;height:500px" ref="cropperEle">
        
        </div>
        <div class="el-dialog__footer">
          <div class="dialog-footer">
            <el-button @click="hideCropper">取 消</el-button>
            <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
          </div>
        </div>
      </div>
    </div>
    
    <input
        style="display: none"
        type="file"
        name
        id="headUpload"
        accept=".jpg, .png, .jpeg"
      />
    
    <div class="preview" v-show="preview == true">
      <div class="mask" @click="closePreview"></div>
      <div :class="`preview-img ${tab == 'H'?'preview-pc':'preview-mobile'}`">
        <img :src="previewImg" alt="">
        <div class="songname">{{songname || '歌名'}}</div>
        <div class="singername">
          <div class="name">{{singername || '歌手名'}}</div><div class="tag"></div>
        </div>
        <div class="preview-mask"></div>
        <div class="preview-close" @click="closePreview"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadPhoto, getPhotoList, deletePhoto } from "../lib/api";
import replaceHttpsImg from '../lib/repalceHttpsImg'
import UploadImage from "@kugou/upload-image"
import md5 from 'md5'

export default {
  mounted() {
    this.initWH();
    this.event();
    this.getList('H');
    this.scroll()
    this.initCopper()
    this.getWorkData()
  },
  beforeDestroy(){

  },
  data() {
    return {
      opacity: 0,
      uploadEle1: null,
      uploadEle2: null,
      tab: 'H',
      H_page: 1,
      V_page: 1,
      pagesize: 20,
      H_pageEnd: false,
      V_pageEnd: false,
      imgBoxHeight: {
        H: 200,
        V: 277,
      },
      H_Arr: [],
      V_Arr: [],
      showArr: [],
      verifyStatus: {
        "3": "审核不通过",
        "1": "审核中...",
        "2": "审核通过",
      },
      loading: false,
      option: {
        img: "", // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.99, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 320, // 默认生成截图框宽度
        autoCropHeight: 180, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [16, 9], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMove: false, //原图是否能拖动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 6
      },
      cropper: false,
      uploadSrc: '',
      toUpload: false,
      preview: false,
      previewImg: '',
      songname: '',
      singername: '',
      imgText: null,
      work_data: []
    };
  },
  methods: {
    event() {
      document
        .getElementById("headUpload")
        .addEventListener("change", this.changeHeadImg);
    },
    finish() {
      if(this.tab == 'H'){
        this.uploadEle1.confirmCropFn()
      }else{
        this.uploadEle2.confirmCropFn()
      }
      this.cropper = false
    },
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    },
    changeHeadImg(e) {
      console.log("upload", e);
      const that = this;
      //判断宽高
      let url = window.URL || window.webkitURL;
      let img = new Image(); //手动创建一个Image对象
      img.src = url.createObjectURL(e.target.files[0]); //创建Image的对象的url
      img.onload = function () {
        console.log("height:" + this.height + "----width:" + this.width);

        //横版
        if(that.tab == 'H') {
          if (this.height < 1080 || this.width < 1920) {
            that.clearHeadInput();
            return window.eventEmitter.emit("toast", {msg: "您上传的图片尺寸太小，请更换图片尺寸>1920*1080像素再重新上传", time: 5000});
          } else if (e.target.files[0].size > 1024 * 1024) {
            //判断大小
            that.clearHeadInput();
            return window.eventEmitter.emit("toast", "图片大小不能超过10MB");
          }
        }
        
        //竖版
        if(that.tab == 'V') {
          if (this.height < 1280 || this.width < 720) {
            that.clearHeadInput();
            return window.eventEmitter.emit("toast", {msg: "您上传的图片尺寸太小，请更换图片尺寸>720*1280像素再重新上传", time: 5000});
          } else if (e.target.files[0].size > 1024 * 1024) {
            //判断大小
            that.clearHeadInput();
            return window.eventEmitter.emit("toast", "图片大小不能超过10MB");
          }
        }

        that.getBase64(e.target.files[0], (res) => {
          that.option.img = res;
          that.cropper = true;
        });
      };
    },
    autoClick() {
      if(this.tab == 'H'){
        this.uploadEle1.upload()
      }else{
        this.uploadEle2.upload()
      }
    },
    clearHeadInput() {
      document.getElementById("headUpload").value = "";
    },
    deletePic(item, index, status){
      let text = status == 2 ? `确定要删除这张写真吗？（删除后，已发布在${this.tab == 'H' ? '电脑端':'移动端'}播放页的写真将同步删除）`:'确定要删除这张写真吗'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletePhoto({
          portrait_source: item.img_source,
          portrait_id: item.img_source === 'ugc' ? item.ugc_id : item.kmr_id
        }).then(()=>{
          this.$message({
            type: 'success',
            message: '删除成功~'
          });
          if(this.tab == 'H'){
            this.H_Arr.splice(index, 1)
          }else{
            this.V_Arr.splice(index, 1)
          }
          //window.eventEmitter.emit("toast", "删除成功");
          //this.getList(this.tab, true)
        })
      });
    },
    initCopper(){
      this.uploadEle1 = new UploadImage({
        appid: 1014,
        size: 1, //压缩尺寸限制，单位MB，默认2MB
        imgRatio: 1, //输出图片与原图的比例，原图尺寸输出为1，默认1，为原图一半时填1/2
        ratio: 1920/1080, //裁剪宽高比
        imgCropper: true, //是否使用裁剪功能，默认为false
        form: "image/jpeg", //输出图片格式，'image/jpeg'、'image/png'，默认image/jpeg
        accept: "image/png,image/jpeg,image/jpg",
        cwidth: 1920, //裁剪输出尺寸
        cheight: 1080, //裁剪输出尺寸
        fileSizeLimit: 10,
        fileSizeLimitTip: "请选择小于10MB的图片~",
        hideBtn: true,
        cropperContainer: this.$refs.cropperEle,
        cropperOptions: {
          viewMode: 1,
          ready: ()=>{
            this.cropper = true
          }
        },
        minWidth: 1920,
        minHeight: 1080,
        minSizeTip: "您上传的图片尺寸太小，请更换图片尺寸大于或等于1920*1080像素再重新上传",
        handleCropImg: (bas64, cb)=>{
          cb && cb(bas64)
          // this.addWaterMarker(bas64, (res)=>{
            // cb && cb(res)
          // })
        },
        log: true,
        //上传成功回调
        result: urlArr => {
          //返回对象数组
          if(urlArr[0].status == 1){
            this.createPortrait(replaceHttpsImg(urlArr[0].url))
          }else{
            window.eventEmitter.emit("toast", "上传失败，请重新选择重试~");
          }
        },
        //失败回调
        fail: (err) => {
          console.log("fail", err);
          if(err != '图片尺寸太小'){
            window.eventEmitter.emit("toast", "上传失败，请重新选择重试~");
          }
        }
      });
      this.uploadEle2 = new UploadImage({
        appid: 1014,
        size: 1, //压缩尺寸限制，单位MB，默认2MB
        imgRatio: 1, //输出图片与原图的比例，原图尺寸输出为1，默认1，为原图一半时填1/2
        ratio: 720/1280, //裁剪宽高比
        imgCropper: true, //是否使用裁剪功能，默认为false
        form: "image/jpeg", //输出图片格式，'image/jpeg'、'image/png'，默认image/jpeg
        accept: "image/png,image/jpeg,image/jpg",
        cwidth: 720, //裁剪输出尺寸
        cheight: 1280, //裁剪输出尺寸
        fileSizeLimit: 10,
        fileSizeLimitTip: "请选择小于10MB的图片~",
        hideBtn: true,
        cropperContainer: this.$refs.cropperEle,
        cropperOptions: {
          viewMode: 1,
          ready: ()=>{
            this.cropper = true
          }
        },
        minWidth: 720,
        minHeight: 1280,
        minSizeTip: "您上传的图片尺寸太小，请更换图片尺寸大于或等于720*1280像素再重新上传",
        handleCropImg: (bas64, cb)=>{
          cb && cb(bas64)
          // this.addWaterMarker(bas64, (res)=>{
            // cb && cb(res)
          // })
        },
        log: true,
        //上传成功回调
        result: urlArr => {
          //返回对象数组
          if(urlArr[0].status == 1){
            this.createPortrait(replaceHttpsImg(urlArr[0].url))
          }else{
            window.eventEmitter.emit("toast", "上传失败，请重新选择重试~");
          }
        },
        //失败回调
        fail: (err) => {
          console.log("fail", err);
          if(err != '图片尺寸太小'){
            window.eventEmitter.emit("toast", "上传失败，请重新选择重试~");
          }
        }
      });
    },
    hideCropper(){
      if(this.tab == 'H'){
        this.uploadEle1.destroy()
      }else{
        this.uploadEle2.destroy()
      }
      this.cropper = false
    },
    removeScroll(){
      //window.removeEventListener("scroll", this.listenScroll, true)
    },
    scroll(){
      //window.addEventListener("scroll", this.listenScroll, true)
    },
    listenScroll(){
      let that = this
      let ele = document.querySelector("body");
      if(that.tab == 'H'){
        if(that.H_pageEnd){return}
      }else{
        if(that.V_pageEnd){return}
      }
      if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100) { //监听滚动到div底部
        that.timer && clearTimeout(that.timer)
        that.timer = setTimeout(() => {
          that.getList(that.tab)
        }, 500);
      }
    },
    changeTab(tab) {
      this.tab = tab
      //重置截图框
      if(tab == 'H') {
          this.option = {
          img: "", // 裁剪图片的地址
          info: false, // 裁剪框的大小信息
          outputSize: 0.99, // 裁剪生成图片的质量
          outputType: "jpeg", // 裁剪生成图片的格式
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 320, // 默认生成截图框宽度
          autoCropHeight: 180, // 默认生成截图框高度
          fixedBox: true, // 固定截图框大小 不允许改变
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [16, 9], // 截图框的宽高比例
          full: false, // 是否输出原图比例的截图
          canMove: false, //原图是否能拖动
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
          enlarge: 6
        }
      } else if(tab == 'V') {
        this.option = {
          img: "", // 裁剪图片的地址
          info: false, // 裁剪框的大小信息
          outputSize: 0.99, // 裁剪生成图片的质量
          outputType: "jpeg", // 裁剪生成图片的格式
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 180, // 默认生成截图框宽度
          autoCropHeight: 320, // 默认生成截图框高度
          fixedBox: true, // 固定截图框大小 不允许改变
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [9, 16], // 截图框的宽高比例
          full: false, // 是否输出原图比例的截图
          canMove: false, //原图是否能拖动
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
          enlarge: 4
        }
      }
      if(this[`${tab}_Arr`].length != 0) {
        this.showArr = this[`${tab}_Arr`]
      } else {
        this.showArr = []
        this.getList(tab)
      }
    },
    initWH() {
      //计算图片高度
      const totalWidth = $("header").width();
      this.imgBoxHeight["H"] = ((totalWidth * 0.229) / 16) * 9;
      this.imgBoxHeight["V"] = ((totalWidth * 0.179) / 9) * 16;
    },
    //refresh: 重新获取
    getList(type, refresh) {
      let _type = type == 'H' ? 3 : 4
      if(refresh){
        if(_type == 3){
          this.H_Arr = []
          this.H_page = 1
          this.H_pageEnd = false
        }else{
          this.V_Arr = []
          this.V_page = 1
          this.V_pageEnd = false
        }
      }
      getPhotoList({
        page: this[`${type}_page`],
        pagesize: this.pagesize,
        portrait_type: _type
      }).then(res => {
        let HArr = [];
        let VArr = [];
        //接口不支持根据类型查询，所以前端根据类型区分
        res.data.list.map((item)=>{
          if(item.img_type == 3){
            //this.H_Arr.push(item)
            HArr.push(item)
          }else if(item.img_type == 4){
            //this.V_Arr.push(item)
            VArr.push(item)
          }
        })
        if(type == 'H'){
          this.H_Arr = HArr;
        }else{
          this.V_Arr = VArr;
        }

        /* if(_type == 3){
          if((this.H_Arr.length < res.data.total) && res.data.list.length > 0){
            this.H_page ++
          }else{
            this.H_pageEnd = true
          }
        }else{
          if((this.V_Arr.length < res.data.total) && res.data.list.length > 0){
            this.V_page ++
          }else{
            this.V_pageEnd = true
          }
        } */
        
        this.showArr = this[`${type}_Arr`]
      })
    },
    //添加水印
    addWaterMarker(imgsrc, cb){
      //创建 canvas 元素
      var canvas = document.createElement('canvas');
      // 隐藏 canvas 元素
      canvas.style.display = 'none';
      canvas.style.zIndex = '-999'
      // 获取 canvas 元素工具箱
      var ctx = canvas.getContext('2d');
      const img = new Image()
      img.setAttribute( 'crossorigin', 'anonymous' )
      img.src = imgsrc
      img.onload = ()=>{
        let width = img.width;
        let height = img.height;
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        if(this.imgText){
          if(this.tab == 'H'){//1920-160，(1080-380)/2
            ctx.drawImage(this.imgText, 1800, 350 , this.imgText.width, this.imgText.height);
          }else{//720-160
            ctx.drawImage(this.imgText, 540, 100 , this.imgText.width, this.imgText.height);
          }
          
          // 将 canvas 转化为图片并且设置为背景
          let resultImgSrc = canvas.toDataURL("image/jpeg")
          cb && cb(resultImgSrc)
        }else{
          const imgText = new Image();
          imgText.setAttribute( 'crossorigin', 'anonymous' )
          imgText.src = "https://webvoobssdl.kugou.com/bca18912f9757ad27a7e0ba050cffbbb.png"
          imgText.onload = ()=>{
            this.imgText = imgText;
            if(this.tab == 'H'){
              ctx.drawImage(imgText, 1800, 350 , imgText.width, imgText.height);
            }else{
              ctx.drawImage(imgText, 540, 100 , imgText.width, imgText.height);
            }
            
            // 将 canvas 转化为图片并且设置为背景
            let resultImgSrc = canvas.toDataURL("image/jpeg")
            cb && cb(resultImgSrc)
          }
        }
      } 
      img.onerror = function () {
        cb && cb(imgsrc);
      }
    },
    //主页作品管理歌曲数
    getWorkData() {
      const time = new Date().getTime()
      this.api({
        apiName: 'musicianWorkData',
        methods: 'GET',
        getData: {
          'appid': window.appid,
          'clienttime': time,
          'token': window.token,
          'clienttype': 2,
          'clientver': 1000,
          'user_id': window.kugouid,
          'key': md5(1014 + 'iYw1iw8z2ji2iphcu80oOo2ki8112p' + 1000 + time),
          'page': 1,
          'pagesize': 1,
          'newver': 1
        }
      }).then(res => {
        //console.log('getWorkData', res)
        this.work_data = res.data.pagedata;
        this.songname = this.work_data.length > 0 ? this.work_data[0].songname : ''
        this.singername = this.work_data.length > 0 ? this.work_data[0].singername : ''
        //console.log('songname', this.songname);
        //console.log('singername', this.singername);
      }) 
    },
    createPortrait(url){
      let type = this.tab == 'H' ? 3 : 4
      uploadPhoto(url, type)
      .then(res => {
        this.$message({
          type: 'success',
          message: '上传成功~'
        });
        if(this.tab == 'H'){
          this.H_Arr.unshift({
            img_source: "ugc",
            ugc_id: res.data.portrait_id,
            review_status: res.data.review_status,
            review_message: res.data.review_message,
            portrait: replaceHttpsImg(url)
          })
        }else{
          this.V_Arr.unshift({
            img_source: "ugc",
            ugc_id: res.data.portrait_id,
            review_status: res.data.review_status,
            review_message: res.data.review_message,
            portrait: replaceHttpsImg(url)
          })
        }
        //this.getList(this.tab, true)
      });
    },
    peviewImage(url){
      this.preview = true;
      this.previewImg = url;
    },
    closePreview(){
      this.preview = false;
      this.previewImg = '';
    }
  },
};
</script>

<style lang="scss" scoped>
.cropper-content{
  position: relative;
  overflow: hidden;
}
.cropper-dialog-contaier{
  opacity: 0
}
.el-dialog{
  width: 640px;
  top: 50%;
  transform: translateY(-50%);
}
.photo {
  //height: calc(100vh - 10px);
  background-color: #fff;
  padding: 36px 100px;
  margin-bottom: 10px;
  header {
    padding-bottom: 15px;
    height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    position: relative;
    .tab-c {
      .active {
        color: #0090ff;
      }
      > div {
        float: left;
        margin-right: 60px;
        line-height: 1.5;
        font-size: 24px;
        color: #666;
        cursor: pointer;
      }
    }
    .upload-tip {
      position: absolute;
      font-size: 18px;
      color: #888888;
      right: 0;
      top: 5px;
      span {
        color: #0090ff;
        cursor: pointer;
        img {
          display: none;
          position: absolute;
          top: 20px;
          left: 110px;
          z-index: 1;
          width: 330px;
        }
        &:hover img {
          display: inline;
        }
      }
    }
  }
  .tip {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 16px;
    padding: 10px 0;
    color: #888888;
  }
  .list {
    width: 100%;
    padding-top: 20px;
    overflow: hidden;
    > div {
      float: left;
      background-color: #f4f4f8;
      position: relative;
      overflow: hidden;
      margin-top: 32px;
      img {
        width: 100%;
      }
      &:hover{
        .delete,.reason{
          display: block;
        }
      }
      .reason, .checking{
        //display: none;
        z-index: 5;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 36px);
        background: rgba(0,0,0,.6);
        color: #fff;
        text-align: center;
        overflow-y: auto;
        .reason-text{
          width: 85%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%)
        }
        &::-webkit-scrollbar-track{
          background-color: rgba(0,0,0,.6);
        }
      }
      .checking{
        display: block;
      }
      .delete{
        z-index: 10;
        display: none;
        position: absolute;
        top: 10px;
        right:10px;
        width: 30px;
        height: 30px;
        background-size:100%;
        background-repeat: no-repeat;
        background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAASFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAADv7+8AAAAAAAD29vbx8fEuLi4AAAAAAAAAAAC5ubnU1NRycnJhYWEAAAAAAACysrL///+f8JTdAAAAF3RSTlOAAHVKLCYI8GNA9/ONdnRXyNqknmRBxNyo6A0AAADKSURBVCjPhZMLDoMgDEArBRUQ5nfc/6brxqDgHL4Yhb40NmkLXUbh6AH8iIpjSfdaQMbpvtbSQ4WXpUb4AVk/4IJH0giXYNQS/iDfuueSVxuCXSEhetIaMnYD2CzfNWnB1xBfnN6BiqchVAwxqgCr1PpIcmxokqKMDfSU+lRXSB+mrUVDkxwbmiQ2NEnVqJxk5yBiphScTPp10ZJ5mb52eXJLuKGzCR/MzA1tj0N7mO5H8X6QCSlqKeRpiQ7H0h28RBmFu6C8vVzBF/elCNWlTKyDAAAAAElFTkSuQmCC');
      }
      .status {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 36px;
        background-color: rgba(0, 0, 0, 0.5);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 10px;
        .text {
          width: 100%;
          line-height: 36px;
          font-size: 16px;
          color: #fff;
          text-align: center;
        }
        .preview-text{
          cursor: pointer;
          width: 100%;
          line-height: 36px;
          font-size: 14px;
          color: #8ff6ff;
          text-align: center;
        }
      }
    }
    .add {
      cursor: pointer;
    }
  }
  & {
    .H {
      > div {
        &:nth-child(4n + 1) {
          margin-left: 0 !important;
        }
      }
    }
    .V {
      > div {
        &:nth-child(5n + 1) {
          margin-left: 0 !important;
        }
      }
    }
  }

  .preview{
    z-index: 50;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.6);
    width: 100%;
    height: 100%;
    color: #fff;
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .preview-img{
      z-index: 5;
      position: absolute;
      top: 50%;
      left: 50%;
      &.preview-pc{
        margin-left: -337.5px;
        margin-top: -190px;
        width: 675px;
        height: 380px;
        .preview-mask{
          background-image: url('https://webvoobssdl.kugou.com/487e8bea1f4e44474820d3ee034d0fef.png');
        }
        .songname{
          z-index: 3;
          padding: 0 20px;
          position: absolute;
          top: 30px;
          left: 0;
          width: 100%;
          font-size: 14px;
          text-align: center;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          box-sizing: border-box;
        }
        .singername{
          z-index: 3;
          position: absolute;
          top: 52px;
          left: 0;
          font-size: 12px;
          padding: 0 20px;
          width: 100%;
          box-sizing: border-box;
          .name{
            width: 100%;
            text-align: center;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .tag{
            display: none;
          }
        }
      }
      &.preview-mobile{
        margin-left: -135px;
        margin-top: -240px;
        width: 270px;
        height: 585px;
        overflow: hidden;
        border-radius: 20px;
        .preview-mask{
          background-image: url('https://webvoobssdl.kugou.com/f9ecd00c4b964c46ea997922955e19d6.png');
        }
        .songname{
          z-index: 3;
          position: absolute;
          left: 20px;
          top: 320px;
          font-size: 12px;
          font-weight: bold;
        }
        .singername{
          z-index: 3;
          position: absolute;
          left: 20px;
          top: 345px;
          display: flex;
          align-items: center;
          .name{
            max-width: 100px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 10px;
          }
          .tag{
            margin-left: 5px;
            width: 130px;
            height: 14px;
            background: url('https://webvoobssdl.kugou.com/2fa9fe47b887445e15845cd77e7852c7.png') no-repeat;
            background-size: 100%;
          }
        }
        img{
          width: auto;
          height: 100%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%)
        }
      }
      img{
        width: 100%;
        height: 100%;
        border-radius: 20px;
      }
      .preview-mask{
        z-index: 2;
        position: absolute;
        top: 0; 
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        background-repeat: no-repeat;
        background-size: 100%;
      }
      .preview-close{
        cursor: pointer;
        position: absolute;
        left: 50%;
        margin-left: -15px;
        bottom: -50px;
        width: 30px;
        height: 30px;
        background: url('https://webvoobssdl.kugou.com/fdf200f58d5c37f03124c743a86aa755.png') no-repeat;
        background-size: 100%;
      }
      
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Photo.vue